import AdminLayout from '../../components/feature/AdminLayout';
import SubscriptionsTable from './components/SubscriptionsTable';

export default function SubscriptionsPage() {
  return (
    <AdminLayout>
      <SubscriptionsTable />
    </AdminLayout>
  );
}
